import styled from "styled-components";

const EditIcon = styled.div`
  filter: brightness(50%);
`;

const FakeCheckbox = styled.div`
  display: flex;
  justify-content: center;
`;

export { EditIcon, FakeCheckbox };
